import React, { useState, useEffect, useContext } from "react";

import {
  Card,
  Grid,
  IconButton,
  FormControl,
  TextField,
  Input,
  MenuItem,
  InputAdornment,
  Button,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { useIntl, FormattedMessage } from "react-intl";
import CircularProgress from "@material-ui/core/CircularProgress";
import UserContext from "contexts/userContext";
import CheckIcon from "@material-ui/icons/Check";
import { green } from "@material-ui/core/colors";
import axios from "axios";
import { formatError, formatMessage } from "utils/MyFunctions";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LocalConvenienceStoreOutlined } from "@material-ui/icons";
// import { ArrowUpwardSharp } from '@material-ui/icons';
import feedbackContext from "contexts/feedbackContext";
import { notify, closeSnack } from "utils/MyFunctions";
import Helper from "utils/Helper";

export default function LivePreviewExample(props) {
  const intl = useIntl();
  const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));
  const BASE_DELAY = 500;
  const NUMBER_OF_RETRIES = 3;
  const { role, setRole, locale } = useContext(UserContext);
  const [loading, setLoading] = React.useState(false);
  const [done, setDone] = React.useState(false);
  const [value, setValue] = React.useState("");
  const [reference, setReference] = React.useState();
  const { feedback, setFeedback, enqueueSnackbar, closeSnackbar } = useContext(
    feedbackContext
  );

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  useEffect(() => {
    console.log("props init is : ", props.init);
    if (props.init) {
      console.log("inside IF");
      setValue(props.init.name);

      setDone(true);
    }
  }, [props.init]);

  useEffect(() => {
    if (props.reset) {
      console.log("reset changed, reset : ", props.reset);
      setValue("");
      setLoading(false);
      setDone(false);
    }
  }, [props.reset]);

  // 2 * 1048576
  const uploadFile = async (event, retries) => {
    if (retries == 0) {
      setLoading(false);
      event.target.value = ""; // clear the file input
      return;
    }
    event.persist(event);
    const filenames = event.target.files;
    console.log("target is : ", event.target);
    console.log("filenames is : ", filenames);

    if (
      filenames &&
      filenames.length > 0 &&
      filenames[0].size > props.fileSizeLimit
    ) {
      // 1 MB in bytes
      notify(
        formatMessage(intl, "alert_file_size", {
          maxSize: props.fileSizeLimit / 1048576,
        }),
        "info",
        "center",
        "bottom",
        true,
        enqueueSnackbar
      );
      event.target.value = ""; // clear the file input
    } else {
      // Handle the file upload logic here
      const fileName = filenames[0].name;
      let fileObject = { file: filenames[0], feature: props.feature };
      if (reference) {
        fileObject.replace_uuid = reference.uuid;
      }

      // if(fileReference[event.target.name]){
      //   fileObject.replace_uuid = fileReference[event.target.name].uuid;
      // }

      // let _b64 = await convertBase64(filenames[0]);
      setLoading(true);
      setDone(false);
      Helper.uploadFile(
        "files/upload",
        fileObject,
        role && role.user ? role.user.unique_identification : null
      )
        .then((response) => {
          setLoading(false);
          if (response.data.success) {
            console.log("SUCCESS!!");
            console.log("index is : ", props.index);
            setDone(true);
            console.log("CALLING PROPS SEND FILE...");
            props.sendFile({
              index: !isNaN(props.index) ? props.index : null,
              file: response.data.file,
            });
            setReference(response.data.file);
            setValue(response.data.file.name);
          } else {
            (async () => {
              if (retries == 1) {
                notify(
                  formatMessage(intl, "alert_file_upload_error"),
                  "error",
                  "center",
                  "bottom",
                  true,
                  enqueueSnackbar
                );
              } else {
                let sleepTime =
                  BASE_DELAY * 2 ** (NUMBER_OF_RETRIES + 1 - retries) +
                  Math.random() * 1000;
                await sleep(sleepTime);
              }
              uploadFile(event, retries - 1);
            })();
          }
        })
        .catch((error) => {
          (async () => {
            if (retries == 1) {
              notify(
                formatError(error),
                "error",
                "center",
                "bottom",
                true,
                enqueueSnackbar
              );
            } else {
              let sleepTime =
                BASE_DELAY * 2 ** (NUMBER_OF_RETRIES + 1 - retries) +
                Math.random() * 1000;
              await sleep(sleepTime);
            }
            uploadFile(event, retries - 1);
          })();
        });

      // setValue(fileName);
    }
  };

  useEffect(() => {
    console.log("reference changed, reference : ", reference);
  }, [reference]);

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    tabPanelRoot: {
      padding: 0,
    },
    panel: {
      width: "100%",
    },
    margin: {
      margin: theme.spacing(0),
    },
    withoutLabel: {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
    },

    textField: {
      width: 300,
    },
  }));

  const classes = useStyles();
  return (
    <>
      <Grid
        item
        justifyContent="center"
        alignItems="center"
        container
        xs={3 * (props.buttonSize ? props.buttonSize : 1)}
        sm={2 * (props.buttonSize ? props.buttonSize : 1)}
        md={props.buttonSize ? props.buttonSize : 1}
      >
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => {
            document.getElementById("file-upload" + props.id).click();
          }}
        >
          <FontAwesomeIcon icon={["fas", "file-upload"]} size="lg" />
        </Button>
        <input
          id={"file-upload" + props.id}
          type="file"
          required={props.required}
          hidden
          accept=".pdf,.docx,.doc"
          // accept=".pdf"
          onChange={(event) => uploadFile(event, NUMBER_OF_RETRIES + 1)}
        />
      </Grid>

      <Grid
        item
        xs={3 * props.size > 12 ? 12 : 3 * props.size}
        sm={2 * props.size > 12 ? 12 : 2 * props.size}
        md={props.size}
      >
        <FormControl fullWidth size="small" variant="outlined">
          <TextField
            label={props.label}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              readOnly: true,
              endAdornment: (loading || done) && (
                <InputAdornment position="end">
                  {loading ? (
                    <CircularProgress size={20} />
                  ) : (
                    <CheckIcon style={{ color: green[500] }} />
                  )}
                </InputAdornment>
              ),
            }}
            id="outlined-adornment-amount"
            color="secondary"
            required={props.required}
            variant="outlined"
            size="small"
            labelWidth={180}
            value={value}
          ></TextField>
        </FormControl>
      </Grid>
    </>
  );
}
